/*  try {
          const res = await axios.get(
            "/extproxy/integrations/object-departments?includeObjects=true"
          );
          console.log("BUBUBUBBU :", res.data);
        } catch (e) {
          console.log("BUBUBUBBU  err:", e);
        } */

import { apiCall } from "@/common/api/ApiResult.model";
import axios from "axios";

interface DepartmentScope {
  departmentId: string;
  departmentName: string;
  objects: Array<{
    internalObjectId: string;
    externalObjectId: string;
    objectName: string;
  }>;
}

export const get_all_employees_and_departments = apiCall<
  void,
  {
    employees: Record<string, string>;
    departments: Record<string, string>;
    employees_count_per_department: Record<string, number>;
    employees_full: Record<
      string,
      {
        email: string;
        name: string;
        dep_id: string;
        dep_name: string;
      }
    >;
  }
>("org-entities-scope", async () => {
  const res = await axios.get(
    "/extproxy/integrations/tests/object-departments?includeObjects=true&objectType=person&enableUnscopedMode=true"
  );

  const deps: DepartmentScope[] = res.data.value.objectDepartments;

  const departments = deps.reduce((acc, dep) => {
    acc[dep.departmentId] = dep.departmentName;
    return acc;
  }, {} as Record<string, string>);

  const employees_full = deps.reduce(
    (acc, dep) => {
      const { departmentId, departmentName, objects } = dep;
      objects.forEach((employee) => {
        acc[employee.internalObjectId] = {
          email: employee.externalObjectId,
          name: employee.objectName || employee.externalObjectId,
          dep_id: departmentId,
          dep_name: departmentName,
        };
      }, {});
      return acc;
    },
    {} as Record<
      string,
      {
        email: string;
        name: string;
        dep_id: string;
        dep_name: string;
      }
    >
  );

  const employees_count_per_department = deps.reduce((acc, dep) => {
    acc[dep.departmentId] = dep.objects.length;
    return acc;
  }, {} as Record<string, number>);

  const employees = deps
    .map((d) =>
      d.objects.map((obj) => {
        return {
          [obj.externalObjectId]: d.departmentId,
          [obj.internalObjectId]: d.departmentId,
        };
      })
    )
    .flat(1)
    .reduce((acc, item) => {
      Object.entries(item).forEach(([k, v]) => {
        acc[k] = v;
      });
      return acc;
    }, {} as Record<string, string>);

  return {
    success: true,
    value: {
      departments,
      employees,
      employees_count_per_department,
      employees_full,
    },
  };
});

export const get_departments = apiCall<void, Record<string, string>>(
  "org-departments",
  async () => {
    const all_departments: Record<string, string> = {};
    let cursor = "";

    do {
      const params = new URLSearchParams({ groupByDepartment: "true" });
      if (cursor) params.set("cursor", cursor);

      const res = await axios.get(
        `/extproxy/integrations/department-familiarities?${params.toString()}`
      );

      const { departmentFamiliarities = [], cursor: next_cursor = "" } =
        res.data.value || {};

      departmentFamiliarities.forEach((dep: any) => {
        all_departments[dep.entityId] = dep.entityName;
      });

      cursor = next_cursor;
    } while (cursor);

    return {
      success: true,
      value: all_departments,
    };
  }
);
